import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserRoleBuilder } from '../../models/builders/user-role.builder';

@Injectable()
export class UserRoleApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}users-roles`;
  }

  searchUsersAndRoles(str: string) {
    const params = new HttpParams().append('search', str);

    return this.httpClient.get(`${this.apiUrl}/search`, { params })
      .pipe(
        map(UserRoleBuilder.fromList)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/user-role-api.service.ts